import axios from 'axios';

export const endpoints = {
    autorizeByApplication: (token) => `linnworksAuth/authorize/${token}`
};

export const autorizeByApplication = token => {
    return axios.get(endpoints.autorizeByApplication(token));
};